import { render, staticRenderFns } from "./AppFilePreviewGroup.vue?vue&type=template&id=2cd6fbca&scoped=true"
import script from "./AppFilePreviewGroup.vue?vue&type=script&lang=js"
export * from "./AppFilePreviewGroup.vue?vue&type=script&lang=js"
import style0 from "./AppFilePreviewGroup.vue?vue&type=style&index=0&id=2cd6fbca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd6fbca",
  null
  
)

export default component.exports